import axios from 'axios';

export default {
    async fetchWorkers(teamId) {
        if (teamId) {
            return axios.get('/workers',
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    params: { teamId }
                });
        }
        return axios.get('/workers',
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async fetchWorkerById(id) {
        return axios.get(`/workers/${id}`);
    },

    async fetchWorkerProfilePicture(id) {
        return axios.get(`/workers/${id}/profile-picture`);
    },

    async addWorker(worker) {
        return axios.post('/workers',
            worker,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateProfilePicture(workerId, picture) {
        return axios.put('/workers/update-profile-picture',
            {id: workerId, picture},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updatePersonalInfo(personalInfo) {
        return axios.put('/workers/update-personal-info',
            personalInfo,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateProfessions(workerId, professions) {
        return axios.put('/workers/update-professions',
            {workerId, professions},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateWorkerCompany(workerId, company) {
        return axios.put('/workers/' + workerId + '/update-company/' + company.id,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateEducations(workerId, educations) {
        return axios.put('/workers/update-educations',
            {workerId, educations},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async updateLanguages(workerId, languages) {
        return axios.put('/workers/update-languages',
            {workerId, languages},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async addOrEditContact(contact) {
        return axios.post('/workers/edit-contact',
            contact,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async deleteContact(contactId) {
        return axios.delete('/workers/delete-contact/' + contactId,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async addOrEditNote(note) {
        return axios.post('/workers/edit-note',
            note,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async deleteNote(noteId) {
        return axios.delete('/workers/delete-note/' + noteId,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    },

    async fetchNextGeneralStatuses(currentStatus) {
        return axios.get(`/general-statuses/next?currentStatus=${currentStatus}`);
    },

    async changeGeneralStatus(newStatusId, workerId, date) {
        return axios.post('/general-statuses',
            {newStatusId, workerId, date},
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}
